import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetMarketAdjustmentsError,
  GetMarketAdjustmentsVariables,
  fetchGetMarketAdjustments,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getMarketAdjustments;

export function useGetMarketAdjustments(
  variables: GetMarketAdjustmentsVariables,
  opts?: UseQueryOptions<Response, GetMarketAdjustmentsError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetMarketAdjustmentsError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/attachments/marketAdjustments',
      operationId: 'getMarketAdjustments',
      variables,
    }),
    async () => {
      const res = await fetchGetMarketAdjustments({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
